import { useAsyncCallback } from "../../hooks/useAsyncCallback";
import { LoaderCircle, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { SidebarMenuButton } from "../ui/sidebar";
import { useUserPreferences } from "./UserPreferencesProvider";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const { isLoading, savePreferences } = useUserPreferences();
  const isDark = resolvedTheme !== "light";

  const { pending, callback: toggleTheme } = useAsyncCallback(async () => {
    const nextTheme = isDark ? "light" : "dark";
    setTheme(nextTheme);
    try {
      await savePreferences({ theme: nextTheme });
    } catch {
      // Error handling is managed in the preferences provider.
    }
  });

  const ThemeIcon = isDark ? Sun : Moon;
  const themeLabel = isDark ? "Light theme" : "Dark theme";

  return (
    <SidebarMenuButton
      tooltip={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-label={pending ? "Saving theme…" : themeLabel}
      disabled={isLoading || pending} aria-busy={pending}
      onClick={() => void toggleTheme()}
    >
      {pending ? <LoaderCircle aria-hidden="true" className="animate-spin motion-reduce:animate-none" /> : <ThemeIcon />}
      <span className="group-data-[collapsible=icon]:hidden">{pending ? "Saving theme…" : themeLabel}</span>
    </SidebarMenuButton>
  );
}
